export const SET_INITIAL_VALUES = "SET_INITIAL_VALUES"
export type SET_INITIAL_VALUES = typeof SET_INITIAL_VALUES

export const SET_PRICE_LEVELS = "SET_PRICE_LEVELS"
export type SET_PRICE_LEVELS = typeof SET_PRICE_LEVELS

export const UPDATE_PRICE_LEVELS = "UPDATE_PRICE_LEVELS"
export type UPDATE_PRICE_LEVELS = typeof UPDATE_PRICE_LEVELS

export const ADD_PRICE_LEVEL = "ADD_PRICE_LEVEL"
export type ADD_PRICE_LEVEL = typeof ADD_PRICE_LEVEL

export const SORT_PRICE_LEVELS = "SORT_PRICE_LEVELS"
export type SORT_PRICE_LEVELS = typeof SORT_PRICE_LEVELS



// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelActionType.ts